import React from "react";
import {useSelector} from "react-redux";
import {css} from "@panda/css";

import {FaqSection} from "@pg-mono/faq";

import {IRPStore} from "../../app/rp_reducer";

export const ForYouFaq = () => {
    const faq = useSelector((store: IRPStore) => store.faq.data);

    return <FaqSection faqContent={faq} titleAlign="center" headlineAs="h3" className={faqStyle} />;
};

const faqStyle = css({
    md: {
        maxWidth: "1576px !important"
    }
});
import React from "react";
import {useSelector} from "react-redux";
import {css} from "@panda/css";

import {FaqSection} from "@pg-mono/faq";

import {IRPStore} from "../../app/rp_reducer";

export const ForYouFaq = () => {
    const faq = useSelector((store: IRPStore) => store.faq.data);

    return <FaqSection faqContent={faq} titleAlign="center" headlineAs="h3" className={faqStyle} />;
};

const faqStyle = css({
    md: {
        maxWidth: "1576px !important"
    }
});
